import { ArriveParkingServiceInterface } from '@/interfaces/api/arrive-parking-service.interface'
import { HttpClientService } from '@/services/api/http-client.service'
import { ParkingAvailabilityDateInterface } from '@/interfaces/entities/parking-availability-date.interface'
import { ParkingAvailabilityLocationInterface } from '@/interfaces/entities/parking-availability-location.interface'
import { ParkingLocationInterface } from '@/interfaces/entities/parking-location.interface'
import { apiRoutes } from '@/constants/api-routes.constants'
import { groupBy } from '@/utilities/group-by'

const groupByDate = groupBy(['date'])

class ArriveParkingService extends HttpClientService implements ArriveParkingServiceInterface {
  async getAvailability(date: string): Promise<any> {
    try {
      const response = await this.get<any>(apiRoutes.arriveParking.getAvailability(date))
      return this.convertAvailabilityModel(response)
    } catch (err) {
      // TODO: Address this tech debt by adding proper type checking
      // @ts-expect-error Untyped error handling
      return HttpClientService.handleError(err)
    }
  }

  async getLocation(locationId: number): Promise<ParkingLocationInterface> {
    try {
      const response = await this.get<ParkingLocationInterface>(apiRoutes.arriveParking.getLocation(locationId))
      return this.convertLocationModel(response)
    } catch (err) {
      // TODO: Address this tech debt by adding proper type checking
      // @ts-expect-error Untyped error handling
      return HttpClientService.handleError(err)
    }
  }

  protected convertAvailabilityModel(availabilityModel: []): ParkingAvailabilityDateInterface[] {
    let availabilityEntries: ParkingAvailabilityDateInterface[] = []
    for (const [key, value] of Object.entries(availabilityModel)) {
      const availabilityLocations = value as []
      const lowestPriceItem: any = availabilityLocations.reduce((prev, curr, index) => {
        const prevItem = prev as any
        const currItem = curr as any
        return prevItem.price < currItem.price ? prev : curr
      })

      if (lowestPriceItem) {
        const grouped = groupByDate(availabilityLocations)
        const eDate = new Date(lowestPriceItem.date)
        const eLocation = value as ParkingAvailabilityLocationInterface
        const monthValue = String(parseInt(`${eDate.getMonth() + 1}`, 0)).padStart(2, '0')
        const dayValue = String(parseInt(`${eDate.getDate()}`, 0)).padStart(2, '0')
        const entry: ParkingAvailabilityDateInterface = {
          date: `${eDate.getFullYear()}-${monthValue}-${dayValue}`,
          firstLotName: lowestPriceItem.lotName,
          firstLocationId: lowestPriceItem.locationId,
          lowestPrice: lowestPriceItem.price,
          lots: availabilityLocations,
          lotsByDateTime: grouped,
        }
        availabilityEntries = [...availabilityEntries, entry]
      }
    }

    // const timeSlots = [...new Set(availabilityEntries.map((entry) => entry.eventId))]

    // console.log('SLOTS:', timeSlots)

    return availabilityEntries
  }

  protected convertLocationModel(locationModel): ParkingLocationInterface {
    return {
      id: locationModel.id,
      name: locationModel.name,
      address1: locationModel.address1,
      city: locationModel.city,
      state: locationModel.state,
      postal_code: locationModel.postal_code,
      entrance_description: locationModel.description,
      photo:
        locationModel.photos && locationModel.photos.length > 0
          ? locationModel.photos[0].sizes.original?.URL ?? ''
          : '',
    }
  }
}

const arriveParkingService = new ArriveParkingService()
export { arriveParkingService, ArriveParkingService }
